<form class="master-form" [formGroup]="userForm" autocomplete="off" [matchValue]="['password', 'confirmPassword']">
  <div class="row">
    <div class="col-sm-2">
      <div class="form-group">
        <label for="">{{ "USERNAME" | translate }}</label>
        <input type="text" class="form-control form-control-sm" autocomplete="off" formControlName="userName" required
          minlength="3" maxlength="15" autofocus />
          <div
          *ngIf="userForm.get('userName')?.touched && userForm.get('userName')?.errors"
              class="formControlRequired"   >
              <div *ngIf="userForm.get('userName')?.hasError('required')">   Username is required (minimum 5 characters)</div>
          </div>

      </div>
    </div>
    <div class="col-sm-2">
      <div class="form-group">
        <label for="">{{ "PASSWORD" | translate }}</label>
        <input type="password" #input autocomplete="off" class="form-control form-control-sm" formControlName="password"
          minlength="6" />
        <div class="error-messages">
          <ng-container *ngFor="let error of error_messages.password">
            <div class="error-message" *ngIf="
                userForm.get('password').hasError(error.type) &&
                (userForm.get('password').dirty ||
                  userForm.get('password').touched)
              ">
              {{ error.message }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-sm-2">
      <div class="form-group">
        <label for="">{{ "REPASSWORD" | translate }}</label>
        <input minlength="5" maxlength="50" type="password" autocomplete="off" class="form-control form-control-sm"
          name="confirmPassword" formControlName="confirmPassword" validateEqual="password" reverse="false" />
        <div class="error-messages">
          <ng-container *ngFor="let error of error_messages.confirmpassword">
            <div class="error-message" *ngIf="
                userForm.get('confirmPassword').hasError(error.type) &&
                (userForm.get('confirmPassword').dirty ||
                  userForm.get('confirmPassword').touched)
              ">
              {{ error.message }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="col-sm-3">
      <div class="form-group">
        <label for="">{{ "PACSPASSWORD" | translate }}</label>
        <input type="text" #input autocomplete="off" class="form-control form-control-sm"
          formControlName="pacsPassword" minlength="6" />
      </div>
    </div>

    <div class="col-sm-3">
      <div class="form-group">
        <sanabel-selectize appcode="1020" formControlName="empId"></sanabel-selectize>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <sanabel-selectize appcode="1041" formControlName="defaultGroup"></sanabel-selectize>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <sanabel-selectize appcode="1065" formControlName="defaultBranch"></sanabel-selectize>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <label for="exampleSelect11">{{ "DEFAULTLANGUAGE" | translate }}</label>
        <select class="form-control form-control-sm" id="exampleSelect11" formControlName="defaultLang">
          <option value="1">English</option>
          <option value="2">عربى</option>
        </select>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-check">
        <label for="exampleSelect111">{{ "SECONDLANGUAGE" | translate }}</label>
        <select class="form-control form-control-sm" id="exampleSelect111" formControlName="secondLang">
          <option value="1">English</option>
          <option value="2">عربى</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row" style="text-align:center">
    <div class="col-sm-3">
      <label for="updateSecLoginUserName">{{ 'UPDATEUSER' | translate }}</label>
      <input style="text-align:center;color: red;" disabled type="text" id="updateSecLoginUserName" class="form-control"
        formControlName="updateSecLoginUserName">
    </div>
    <div class="col-sm-3">
      <div class="form-group">
          <label for="updateDate">{{ 'LASTUPDATEDATE' | translate }}</label>
          <input style="text-align:center;color: red;"  formControlName="updateDate" class="form-control" disabled />
      </div>
  </div>

</div>
  <div class="row">
    <div class="col-sm-3">
      <div class="form-check">
        <label class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" formControlName="workEncrypLink" />
          <span class="custom-control-indicator"></span>
          <span class="custom-control-description">{{
            "WORKENCRYPLINK" | translate
            }}</span>
        </label>
      </div>
    </div>

    <div class="col-sm-3">
      <div class="form-check">
        <label class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" formControlName="active" checked="on" />
          <span class="custom-control-indicator"></span>
          <span class="custom-control-description">{{
            "ACTIVE" | translate
            }}</span>
        </label>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-check">
        <label class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" formControlName="admin" />
          <span class="custom-control-indicator"></span>
          <span class="custom-control-description">{{
            "ADMIN" | translate
            }}</span>
        </label>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group">
        <label for="">{{ "MAPPEDUSERNAME" | translate }}</label>
        <input type="text" class="form-control form-control-sm" autocomplete="off" formControlName="mappedUserName"
          minlength="3" maxlength="15" autofocus />

      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <!-- (click)="CheckPassword($event, input.value)"  -->
        <btns-ctrl [disabled]="userForm.invalid && activeTab == 1" [paramsArr]="controlsParams"
        (clicked)="onClicked($event)">
        </btns-ctrl>
      </div>
    </div>
  </div>
</form>
